import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
// import { FunctionService } from 'vhobjects-admin';
// import { EditNameComponent } from '.vhobjects-service';

/**
 * Phần mở rộng của menu
 */
interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  _id: string;
  link_page?: string;
  link_website?: string;
  subData?: any;
  icon?: string;
  group?: string,
  item?: any,
  groupParent?: string,
  id_page_category?: string;
  id_freeblock?: string;
  type?: string;
  click_action?: string;
  scroll_block_id?: string;
  scroll_distance?: number;
}
/**
 * Dạng data của 1 menu khi truyền đi và nhận được khi return
 */
interface MenuNode {
  name: string;
  children?: MenuNode[];
  group?: string,
  _id: string;
  subData?: any;
  item?: any,
  link_page?: string;
  link_website?: string;
  icon?: string;
  click_action?: string;
  scroll_block_id?: string;
  scroll_distance?: number;
  groupParent?: string,
  id_page_category?: string;
  id_freeblock?: string;
  type?: string;
}

@Component({
  selector: 'atw-menu-horizontal-admin',
  templateUrl: './menu-horizontal-admin.component.html',
  styleUrls: ['./menu-horizontal-admin.component.scss']
})

export class AtwMenuHorizontalAdmin  implements OnInit {
  @Input() data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, z_index}
  @Input() type: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, z_index}

  dataReturned: any = [];
  visibleSub = {}; // biến này xác định sub-menu được ẩn hay hiện.
  dataAddMenu = {};  // biến này lưu giá trị khi thêm menu cha
  dataEditMenu = {}; // biến này lưu giá trị khi sửa menu cha
  dataAddSubMenu = {};// biến này lưu giá trị khi thêm menu con
  dataEditSubMenu = {};// biến này lưu giá trị khi sưa menu con
  isOpenAddMenu: boolean = false; // biến này lưu trạng thái mở form thêm menu
  isOpenEditMenu: boolean = false;// biến này lưu trạng thái mở form sửa menu
  isOpenAddFormSubMenu: boolean = false; // biến này lưu trạng thái mở form thêm submenu
  isOpenEditFormSubMenu: boolean = false;// biến này lưu trạng thái mở form sửa submenu
  isCallingCate: boolean = false;
  checkExistIdCategory: boolean = false;
  dataLoaded: boolean;
  blocks_of_page: any;
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  isAutoTranslate: boolean;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private ref: ChangeDetectorRef,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    private nzModalService: NzModalService,
    private languageService: LanguageService
  ) {
   
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    if (isPlatformBrowser(this.platformId)) {
      // get hết block blank cho cấu hình cuộn đến block
      this.getAllBlockBlank();

      setTimeout(() => {
        this.getDataCate();
      }, 200);

      this.getData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (isPlatformBrowser(this.platformId))
      if (changes.data && !changes.data.firstChange) {
        this.getData();
      }
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId))
      if (this.isCallingCate) {
        this.getDataCate();
        this.ref.detectChanges();
        this.isCallingCate = false;
      }
  }


  getAllBlockBlank() {
    let items:any = []

    this.vhQueryAutoWeb.getPages()
    .then(async (res:any) => {
      for (const page of res) {
        const blocks = await this.vhQueryAutoWeb.getBlocks_byFields({id_page: {$eq: page._id} });


        const item = {}
        for (const key of Object.keys(page)) {
          if (key.startsWith('name_')) {
            item[key] = page[key];
          }
        }
        items = [
          ...items,
          {
            ...item,
            _id: page._id,
            blocks: blocks
          }
        ]
      }

      this.blocks_of_page = items;
    })
  }

  /**
   * Lấy dữ liệu từ 
   */
  getData() {
    if (this.dataLoaded) return; // Nếu dữ liệu đã được tải, không gọi API nữa
    this.dataSource.data = this.data.staticdata.menu_data;
    this.dataLoaded = true;
  }

  // Phương thức đóng modal
  closeModal(): void {
    this.nzModalService.closeAll();
  }


  //---------------------------------------------- CÁC THAO TÁC XỬ LÝ FORM MENU CHA -----------------------------------------\\

  /**
   * Mở form thêm menu
   */
  openAddMenuItem() {
    this.isOpenAddMenu = true;
    this.dataAddMenu = {
      menu: {
        type: 'none',
        group: 'link',
        groups: this.data['groups'] || ["link", "category", "pop-up"],
        click_action: 'scroll_to_top',
        scroll_block_id: '',
        link_page: '',
      },
      blocks_of_page: this.blocks_of_page
    };
  }
  /**
   * Đóng form thêm menu
   */
  isCancelFormAddMenu(event) {
    this.isOpenAddMenu = event;
  }
  /**
   * Lấy từ liệu khi Lưu từ form thêm menu
   */
  getDataFormAdd(event) {
    this.dataSource.data = [...this.dataSource.data, event.menu];
    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }

  /**
   * Kiểm tra là menu hay submenu và mở form sửa menu
   */
  openEdit(item) {
    if (item.level === 0) {
      this.openEditMenuItem(item)
    } else {
      this.openEditSubMenuItem(item)
    }
  }

  /**
   * Mở form sửa menu
   */
  openEditMenuItem(item) {
    let temp = { ...item }; // biến tạm thời để lưu menu item để khi edit thì không edit tực tiếp lên tree
    this.isOpenEditMenu = true;
    this.dataEditMenu = {
      item: temp,
      type: temp.type,
      groups: this.data['groups'] || ["link", "category", "pop-up"],
      blocks_of_page: this.blocks_of_page
    }
  }
  /**
   * Đóng form sửa menu
   */
  isCancleFormEditMenu(event) {
    this.isOpenEditMenu = event
  }
  /**
   * Lấy dữ liệu khi Lưu từ form chỉnh sửa menu
   */
  getValueFormEditMenu(event) {
    this.dataSource.data = this.dataSource.data.map((item) => {
      if (event.item._id !== item._id) {
        return item;
      }
      return {
        ...item,
        ...event.item,
        click_action: event.item.click_action ? event.item.click_action : undefined,
        scroll_block_id: event.item.scroll_block_id ? event.item.scroll_block_id : undefined,
        scroll_distance: event.item.scroll_distance,
        link_page: event.item.link_page != undefined ? event.item.link_page : undefined,
        link_website: event.item.link_website ? event.item.link_website : undefined,
        icon: event.item.icon ? event.item.icon : undefined,
        children: (event.item.group != item.group ? [] : item.children),
        subData: (event.item.group != 'category' && item.group == 'category' ? [] : item.subData),
        id_page_category: event.item.id_page_category ? event.item.id_page_category : undefined,
        id_freeblock: event.item.id_freeblock ? event.item.id_freeblock : undefined,
      }
    });


    // Đồng bộ dữ liệu giữa cây mat-tree và data thực hiện ở file ts
    this.dataSource.data = this.dataSource.data;
    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }


  //------------------------------------------------- CÁC THAO TÁC XỬ LÝ FORM SUBMENU ---------------------------------------\\

  /**
   * Mở form thêm submenu
   */
  openAddSubMenuItem(item) {
    this.isOpenAddFormSubMenu = true;
    this.checkExistIdCategory = item.id_page_category ? true : false;
    // Thêm dữ liệu sub menu để truyền vao form thêm submenu
    this.dataAddSubMenu = {
      item: item,
      childMenu: {
        type: item.id_page_category ? 'category' : (item.id_freeblock ? 'block' : 'none'),
        groupParent: item.group,
        click_action: item.subData?.length > 0 ? item.subData[0].click_action : 'scroll_to_top',
        scroll_block_id: item.subData?.length > 0 ? item.subData[0].scroll_block_id : '',

      },
      blocks_of_page: this.blocks_of_page
    }
  }
  /**
   * Đóng form thêm submenu
   */
  isCancelFormAddSub(event) {
    this.isOpenAddFormSubMenu = event;
  }
  /**
   * Lấy từ liệu khi Lưu từ form thêm submenu
   */
  getValueFormAddSub(event) {
    const childMenu = event.childMenu; // note hien
    // get node trong tree
    const result = this.deepSearch(this.dataSource.data, event.item._id)
    // check group của node và thêm vào data tương ứng
    if (event.item.group === "category" || event.item.group === "pop-up-subcategory") {
      result.subData = childMenu.listPageCategorySelected.length > 0 ? [childMenu] : event.subData
    } else {
      // Kiểm tra menu có children?
      if (result.children && result.children.length > 0) {
        // Nếu có sẽ thêm menu con vào menu cha
        result.children.push(childMenu)
      } else {
        // Không có sẽ tạo children[]
        result.children = [childMenu]
      }
    }
    // Đồng bộ dữ liệu giữa mat-tree và file ts
    this.dataSource.data = this.dataSource.data;
    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }

  /**
   * Mở form sửa submenu
   */
  openEditSubMenuItem(item) {
    let temp = { ...item }; // biến tạm thời để lưu menu item để khi edit thì không edit tực tiếp lên tree
    this.isOpenEditFormSubMenu = true;
    this.dataEditSubMenu = {
      childMenu: temp,
      // index: index,
      type: temp.type,
      blocks_of_page: this.blocks_of_page
    }
  }
  /**
   * Đóng form sửa submenu
   */
  isCancleFormEditSub(event) {
    this.isOpenEditFormSubMenu = event;
  }
  /**
   * Lấy từ liệu khi Lưu từ form sửa submenu
   */
  getValueFormEditSub(event) {
    const object = this.deepSearch(this.dataSource.data, event.childMenu._id)
    object.type = event.childMenu.type;
    object.icon = event.childMenu.icon;
    // object.name = event.childMenu.name;
    // assign all field start with name_
    for (let key in event.childMenu) {
      if (key.includes('name_')) {
        object[key] = event.childMenu[key];
      }
    }
    object.link_page = event.childMenu.link_page;
    object.click_action = event.childMenu.click_action;
    object.scroll_block_id = event.childMenu.scroll_block_id;
    object.scroll_distance = event.childMenu.scroll_distance;
    object.link_website = event.childMenu.link_website;
    this.dataSource.data = this.dataSource.data; // dòng này làm cho menu bị đóng khi chọn/xóa icon
    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }


  //------------------------------------------------- CÁC THAO TÁC XỬ LÝ TREE ---------------------------------------\\

  /**
   * Hàm duyệt cây
   */
  loopTree(array, click_action, scroll_block_id) {
    for (let i = 0; i < array.length; i++) {
      array[i].group = "category"
      array[i].click_action = click_action
      array[i].scroll_block_id = scroll_block_id
      if (array[i].children && array[i].children.length > 0) {
        this.loopTree(array[i].children, click_action, scroll_block_id);
      }
    }
    return array;
  }

  /**
   * Hàm tìm kiếm node tree
   */
  deepSearch(array, targetId, type = "") {
    for (let i = 0; i < array.length; i++) {
      if (array[i]._id === targetId) {
        return array[i];
      }
      if (array[i].children && array[i].children.length > 0) {
        const result = this.deepSearch(array[i].children, targetId, type);
        if (!!result) {
          if (type === "delete") {
            return array[i]
          }
          return result;
        }
      }
    }
    return null;
  }

  /**
   * Lấy giá trị true để gọi lại hàm getCate khi thêm sub category
   */
  getDataCategoryAgain(event) {
    this.isCallingCate = event;
  }

  /**
   * Lấy cây danh mục hiển thị
   */
  getDataCate() {
    this.dataSource.data?.forEach((cates) => {
      if (cates.subData) {
        cates.subData.map((cate) => {
          if (cate.listPageCategorySelected) {
            this.vhQueryAutoWeb.getCategoryTree_byIdCategoryArray(cate.listPageCategorySelected)
              .then((response: any) => {
                if (response.vcode === 0) {
                  // set danh mục vào group category
                  const dataRes = response.data
                  /**
                   *  Hàm này sắp xếp lại danh mục theo thứ tự đã chọn
                   * ví dụ cate.listPageCategorySelected = ['123', '456', '789']
                   * dataRes = [{_id: '789'}, {_id: '123'}, {_id: '456'}]
                   * sau khi sắp xếp sẽ là [{_id: '123'}, {_id: '456'}, {_id: '789'}]
                   */

                  const sorted = this.sortByOrder(dataRes, cate.listPageCategorySelected);

                  cates.children = this.loopTree(sorted, cate.click_action, cate.scroll_block_id)
                  this.data.staticdata = {
                    ...this.data.staticdata,
                    menu_data: this.dataSource.data
                  }
                  this.updateValueMenu({
                    staticdata: {
                      ...this.data.staticdata,
                      menu_data: this.dataSource.data
                    }
                  });
                  this.dataSource.data = this.dataSource.data
                }
              })
              .catch((error: any) => {
                
              });
          }
          else {
            cate.children = []
            this.data.staticdata = {
              ...this.data.staticdata,
              menu_data: this.dataSource.data
            }
            this.updateValueMenu({
              staticdata: {
                ...this.data.staticdata,
                menu_data: this.dataSource.data
              }
            });
            this.dataSource.data = this.dataSource.data
          }
        });
      }
    })

  }

  sortByOrder(arr: any[], order: number[]): any[] {
    const orderMap = new Map(order.map((id, idx) => [id, idx]));

    return arr
      .map(item => ({
        ...item,
        children: item.children ? this.sortByOrder(item.children, order) : item.children
      }))
      .sort((a, b) => {
        const aIdx = orderMap.has(a._id) ? orderMap.get(a._id)! : Infinity;
        const bIdx = orderMap.has(b._id) ? orderMap.get(b._id)! : Infinity;
        return aIdx - bIdx;
      });
  }

  /**
   * Xử lí data get về từ mat-tree
   */
  private flatNodeCache = new Map<string, FlatNode>(); // key = _id

  private _transformer = (node: MenuNode, level: number) => {
    const id = node._id;
    let flat = this.flatNodeCache.get(id);
    if (!flat) {
      flat = {
        expandable: !!node.children?.length,
        name: node.name,
        level,
        _id: id,
        link_page: node.link_page,
        link_website: node.link_website,
        subData: node.subData,
        icon: node.icon,
        group: node.group,
        groupParent: node['groupParent'],
        id_page_category: node.id_page_category,
        id_freeblock: node.id_freeblock,
        type: node.type,
        click_action: node.click_action,
        scroll_block_id: node.scroll_block_id,
        scroll_distance: node.scroll_distance
      } as FlatNode;
      this.flatNodeCache.set(id, flat);
    } else {
      // chỉ CẬP NHẬT field, KHÔNG tạo object mới
      flat.expandable = !!node.children?.length;
      flat.name = node.name;
      flat.level = level;
      flat.link_page = node.link_page;
      flat.link_website = node.link_website;
      flat.subData = node.subData;
      flat.icon = node.icon;
      flat.group = node.group;
      flat.groupParent = node['groupParent'];
      flat.id_page_category = node.id_page_category;
      flat.id_freeblock = node.id_freeblock;
      flat.type = node.type;
      flat.click_action = node.click_action;
      flat.scroll_block_id = node.scroll_block_id;
      flat.scroll_distance = node.scroll_distance;
    }

    // copy các field bắt đầu bằng 'name'
    for (const key in node) {
      if (key.startsWith('name')) (flat as any)[key] = (node as any)[key];
    }

    return flat;
  };

  treeControl = new FlatTreeControl<FlatNode>(
    (node) => node.level,
    (node) => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: FlatNode) => {
    return node.level === 0 ? true : node.expandable
  };

  /**
   * Tìm node cha của mat-tree (Sử dụng hàm riêng)
   */
  findParrentNode(menu) {
    let id = ""
    const { treeControl } = this;
    const currentLevel = treeControl.getLevel(menu);

    // level node !== 0 thì tìm node cha bằng 0 thì lấy chính nó
    if (currentLevel != 0) {
      const index = treeControl.dataNodes.indexOf(menu) - 1;

      for (let i = index; i >= 0; i--) {
        const currentNode = treeControl.dataNodes[i];

        if (treeControl.getLevel(currentNode) < currentLevel) {
          id = currentNode?._id
          break;
        }
      }
    }
    return { currentLevel, id }
  }

  // ----------------------------------------------- CÁC THAO TÁC XỬ LÝ XÓA MENU CHA -----------------------------------\\

  /**
   * Xóa menu-item
   */
  removeMenuItem(menu) {
    const idChildren = menu._id
    // tim kiem node trong mat-tree
    const nodeParrent = this.findParrentNode(menu);
    let idParent = menu._id
    // Nếu menu là menu cấp 0 thì sẽ xoá tất cả /
    if (nodeParrent.currentLevel == 0) {
      const arr = this.dataSource.data.filter(item => item._id !== idParent)
      this.dataSource.data = arr
    } else {
      // Tìm đến menu cha của menu đó và xoá
      let result = this.deepSearch(this.dataSource.data, nodeParrent.id);
      let arr = result.children.filter((item) => item._id !== idChildren)
      result.children = arr
    }
    this.dataSource.data = this.dataSource.data

    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }

    // thực hiện xóa menu cha và menu con
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }


  // ---------------------------------------------- CÁC THAO TÁC CHUNG CỦA MENU VÀ SUBMENU --------------------------------------\\

  /**
   * Hàm thêm icon
   */
  addIconToParent(menu) {
    // Mở form chọn icon
    // const dialogRef = this.dialog.open(ChooseIconComponent, {
    //   width: '80vw',
    //   height: '70vh',
    //   disableClose: false,
    // });
    // // Update icon vào các menu
    // dialogRef.afterClosed().subscribe((result) => {
    //   if (result) {
    //     menu['icon'] = result.icon;
    //   }
    //   const event = {}
    //   if (menu.level !== 0) {
    //     event['childMenu'] = menu;
    //     this.getValueFormEditSub(event);
    //   }
    //   else {
    //     event['item'] = menu;
    //     this.getValueFormEditMenu(event);
    //   }
    // });

    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: null,
      nzWidth: '80vw',
      nzCloseIcon: null,
      nzBodyStyle: { height: '70vh', overflow: 'auto' },
      nzContent: ChooseIconComponent,
      nzComponentParams: {
        type: 'nz'
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
      if (result) {
        menu['icon'] = result.icon;
      }
      const event = {}
      if (menu.level !== 0) {
        event['childMenu'] = menu;
        this.getValueFormEditSub(event);
      }
      else {
        event['item'] = menu;
        this.getValueFormEditMenu(event);
      }
    });
  }

  /**
   * Hàm xóa icon
   */
  deleteIcon(menu) {
    if (menu.icon) {
      delete menu['icon']
    }
    const event = {}
    if (menu.level !== 0) {
      event['childMenu'] = menu;
      this.getValueFormEditSub(event);
    }
    else {
      event['item'] = menu;
      this.getValueFormEditMenu(event);

    }
  }

  /**
   * Hàm cập nhật lên database
   */
  updateValueMenu(value) {
    if (this.type == 'admin') {
      if (!this.data.hasOwnProperty('fieldUpdate')) this.data['fieldUpdate'] = [] 
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.data._id)) this.functionService.objectsAndBlocksUpdated.push(this.data)
      if (!this.data['fieldUpdate'].includes('staticdata')) this.data['fieldUpdate'].push('staticdata')
        this.vhEventMediator.notifyOnConfigChanged({ code: this.data._id, status: 'update-UI', id_parent: this.data.id_block || this.data.id_object });
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.data._id, value)
      .then((rsp: any) => {
        if (rsp.vcode === 0) {
          
        }
      }, error => {
        
      })
  }

  //đệ quy tìm node cha level 0
  findRootNode(id: string, nodes: any): any {
    for (const node of nodes) {
      const parent = this.findParentNodeById(id, [node]);
      if(parent) return node;
    }
    return null;
  }

  flattenIds(nodes: any[]): string[] {
    const ids: string[] = [];
    const walk = (arr: any[]) => {
      for (const n of arr) {
        ids.push(n._id);
        if (n.children?.length) {
          walk(n.children);
        }
      }
    };
    walk(nodes);
    return ids;
  }

  /**
   * Hàm thực hiện xử lý khi thay đổi vị trí của menu__item
   *
   * @param event
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    const id = event.item.element.nativeElement.id

    if(event.item.element.nativeElement.getAttribute('data-level') == '0') {
      moveItemInArray(this.dataSource.data, event.previousIndex, event.currentIndex);
    }
    else if(event.item.element.nativeElement.getAttribute('group') == 'category' || event.item.element.nativeElement.getAttribute('group') == 'pop-up-subcategory') {
      const parent = this.findParentNodeById(id, this.dataSource.data);
      const index = parent?.children?.findIndex((item:any) => item._id == id);
      const delta = event.currentIndex - event.previousIndex 
      const to = this.clamp(index + delta, parent?.children?.length - 1);
      moveItemInArray(parent.children, index, to);

      const parentNodeLevel0 = this.findRootNode(id, this.dataSource.data);

      if(parentNodeLevel0) {
        const cloneNode = JSON.parse(JSON.stringify(parentNodeLevel0))
        const listIds = this.flattenIds(cloneNode.children || []);
        parentNodeLevel0.subData[0].listPageCategorySelected = listIds;
      }
    }
    else {
      const parent = this.findParentNodeById(id, this.dataSource.data);
      const index = parent?.children?.findIndex((item:any) => item._id == id);
      const delta = event.currentIndex - event.previousIndex 
      const to = this.clamp(index + delta, parent?.children?.length - 1);
      moveItemInArray(parent.children, index, to);
    }

    this.dataSource.data = this.dataSource.data;
    this.data.staticdata = {
      ...this.data.staticdata,
      menu_data: this.dataSource.data
    }
    this.updateValueMenu({
      staticdata: {
        ...this.data.staticdata,
        menu_data: this.dataSource.data
      }
    });
  }

  trackById = (_: number, node: FlatNode) => node._id;

  clamp(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }

  findParentNodeById(id: string, nodes: MenuNode[]): MenuNode | null {
    for (let node of nodes) {
      if(node.children && node.children.some((child:any) => child._id == id)) return node;

      if(node.children) {
        const found = this.findParentNodeById(id, node.children);
        if(found) return found;
      }
    }
    return null;
  }

}
